import {
    AdminPanelEventsEnum,
    AdminPanelEventType,
    getAdminPanelEventName
} from "@share/common/admin-panel/AdminPanelEvents";
import { EventBus } from "@common/EventBus";

export abstract class AdminPanelEventObserverBase {
    protected eventName = '';
    protected readonly handlerLink: () => Promise<void>
//@todo remove component from the constructor
    protected constructor(eventType: AdminPanelEventType) {
        this.eventName = getAdminPanelEventName(AdminPanelEventsEnum.eventEvents, eventType);
        this.handlerLink = this.handler.bind(this);
        EventBus.$on(this.eventName, this.handlerLink);
    }

    async handler() { return; }

    unsubscribe() {
        EventBus.$off(this.eventName, this.handlerLink);
    }
}
